//mui
import {Theme} from '@mui/material';

export const MuiSelect = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			'& .MuiSelect-select': {
				padding: '10px 12px',
				overflow: 'visible',

				'&:hover > div': {
					color: 'var(--neutral-300)',
					opacity: '0.7',
				},
			},
			'& .MuiSelect-icon': {
				marginTop: '4px',
			},
			'& .MuiSelect-nativeInput': {
				color: theme.palette.neutral900,
			},
			'& fieldset': {
				top: 0,
				legend: {
					display: 'none',
				},
			},

			'& .MuiSelect-select.Mui-error': {
				color: theme.palette.error500,

				'&::placeholder, em': {
					color: theme.palette.error500,
				},
			},
		}),
	},
};
